<template>
	<div class="layer-project" data-project-name="lg-ess">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<section class="project-visual">
				<div>
					<h1 class="project-tit">LG Chem ESS</h1>
					<a
						href="http://www.lgessbattery.com/eu/main/main.lg"
						class="link"
						target="_blank"
						>www.lgessbattery.com/eu/main/main.lg</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<div class="project-overview-tit"><strong>Overview</strong></div>
					<p class="project-overview-desc">
						LG화학 ESS 파트너 포털 사이트로 메뉴 체계 개선, 검색 기능 강화
						작업을 진행하였습니다. <br />Certified Installer Test를 시스템화하여
						Installer의 응시 및 결과까지 확인할 수 있는 One-Step 프로세스를
						제공하여 사용자의 편의성을 강화하였습니다.
					</p>
					<div class="diagram-wrap">
						<ul class="diagram">
							<li class="item">Total<br />Solution</li>
							<li class="item">Sustainability</li>
							<li class="item">Expertise</li>
							<li class="item">Global Production</li>
							<li class="item">Technology</li>
						</ul>
					</div>
				</div>
			</section>
			<section class="section pc-web-main">
				<div class="inner-section">
					<strong class="project-subtit">PC Web</strong>
					<div class="swiper-container">
						<ul class="swiper-wrapper">
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lg-ess/pc-web-main-01@m.jpg"
								/>
							</li>
							<li class="swiper-slide">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lg-ess/pc-web-main-02@m.jpg"
								/>
							</li>
						</ul>
						<div class="swiper-pagination"></div>
					</div>
				</div>
			</section>
			<section class="section home-battery">
				<div class="inner-section">
					<strong class="project-subtit">Home Battery</strong>
					<p class="project-desc">
						A home battery can store surplus energy generated from rooftop solar
						panels for use when needed. When the sun has set,
						<br class="break-w" />energy demand is high, or there is a
						black-out, you can use the energy stored in your home battery to
						meet your energy needs at no extra cost. <br class="break-w" />In
						addition, a home battery helps you pursue a goal of energy
						self-consumption and ultimately energy-independence.
					</p>
					<div class="swiper-area">
						<div class="swiper-container">
							<ul class="swiper-wrapper">
								<li class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/lg-ess/home-battery-01@m.jpg"
										data-break="m-tw"
									/>
								</li>
								<li class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/lg-ess/home-battery-02@m.jpg"
										data-break="m-tw"
									/>
								</li>
							</ul>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</section>
			<section class="section ups-battery">
				<div class="inner-section">
					<strong class="project-subtit">Grid/C&amp;I/UPS Battery</strong>
					<p class="project-desc">
						Energy Storage System(ESS) is a system that can store energy. Simply
						put, it is a huge battery. <br class="break-w" />The ESS provides
						solutions for applications throughout the power supply system
						including Grid-scale, C&I (Commercial and Industrial)
						<br class="break-w" />and UPS (Uninterruptible Power Supply). Its
						main applications include Peak Shifting, Renewable Integration,
						Frequency Regulation and Power Backup.
					</p>
					<div class="img-wrap">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lg-ess/ups-battery-01@m.jpg"
						/>
					</div>
				</div>
			</section>
			<section class="section mobile-web-main">
				<div class="inner-section">
					<strong class="project-subtit">Mobile Web</strong>
					<div class="img-wrap">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lg-ess/mobile-web-main-01@m.png"
						/>
					</div>
				</div>
			</section>
			<section class="section mobile-web-sub">
				<div class="inner-section">
					<div class="swiper-container">
						<ul class="swiper-wrapper">
							<li class="swiper-slide">
								<img
									src="/static/img/project-detail/lg-ess/mobile-web-sub-01.png"
									alt=""
								/>
							</li>
							<li class="swiper-slide">
								<img
									src="/static/img/project-detail/lg-ess/mobile-web-sub-02.png"
									alt=""
								/>
							</li>
							<li class="swiper-slide">
								<img
									src="/static/img/project-detail/lg-ess/mobile-web-sub-03.png"
									alt=""
								/>
							</li>
						</ul>
						<div class="swiper-pagination"></div>
					</div>
				</div>
			</section>
			<section class="section style">
				<div class="inner-section">
					<div class="point-font-wrap">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lg-ess/point-font01@m.png"
								data-break="m-tw"
							/>
						</div>
					</div>
					<div class="point-color-wrap">
						<ul class="point-color">
							<li class="item"><div>#00aad2</div></li>
							<li class="item"><div>#002c5f</div></li>
							<li class="item"><div>#6e5e3c</div></li>
							<li class="item"><div>#666666</div></li>
							<li class="item"><div>#cba111</div></li>
							<li class="item"><div>#e63312</div></li>
						</ul>
					</div>
				</div>
			</section>
			<!-- Details [e] -->
			<!-- Project Client [s] -->
			<section class="project-client">
				<strong class="a11y-hidden">LG Chem ESS Battery Division</strong>
			</section>
			<!-- Project Client [e] -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var isPcWebMain = false;
		var pcWebMainSwiper;
		var isHomeBatterySwiper = false;
		var homeBatterySwiper;
		var isMobileWebSub = false;
		var mobileWebSubSwiper;

		pcWebMainSet();
		homeBatterySet();
		mobileWebSubSet();

		$(window).on("resize", function () {
			resizeSet();
		});

		function resizeSet() {
			var w = $(window).outerWidth();
			if (w >= 712 && isPcWebMain) {
				pcWebMainSwiper.destroy();
				isPcWebMain = false;
			} else {
				pcWebMainSet();
			}

			// if (w >= 1280 && isHomeBatterySwiper) {
			//     homeBatterySwiper.destroy();
			//     isHomeBatterySwiper = false;
			// } else {
			//     homeBatterySet();
			// }

			if (w >= 712 && isMobileWebSub) {
				mobileWebSubSwiper.destroy();
				isMobileWebSub = false;
			} else {
				mobileWebSubSet();
			}
		}

		function pcWebMainSet() {
			var w = $(window).outerWidth();

			if (isPcWebMain | (w >= 712)) {
				return;
			}
			isPcWebMain = true;
			pcWebMainSwiper = new Swiper(".pc-web-main .swiper-container", {
				slidesPerView: "auto",
				spaceBetween: 15,
				centeredSlides: true,
				pagination: {
					el: ".pc-web-main .swiper-pagination",
					clickable: true,
				},
			});
		}

		function homeBatterySet() {
			var w = $(window).outerWidth();

			// if (isHomeBatterySwiper | w >= 712) {
			//     return;
			// }
			isHomeBatterySwiper = true;
			homeBatterySwiper = new Swiper(".home-battery .swiper-container", {
				slidesPerView: "auto",
				spaceBetween: 0,
				// centeredSlides: true,
				pagination: {
					el: ".home-battery .swiper-pagination",
					clickable: true,
				},
				breakpoints: {
					// when window width is >= 711px
					711: {
						spaceBetween: 15,
					},
					// when window width is >= 1279px
					1279: {
						spaceBetween: 92,
					},
				},
			});
		}

		function mobileWebSubSet() {
			var w = $(window).outerWidth();

			if (isMobileWebSub | (w >= 712)) {
				return;
			}
			isMobileWebSub = true;
			mobileWebSubSwiper = new Swiper(".mobile-web-sub .swiper-container", {
				slidesPerView: "auto",
				spaceBetween: 30,
				centeredSlides: true,
				pagination: {
					el: ".mobile-web-sub .swiper-pagination",
					clickable: true,
				},
			});
		}
	},
};
</script>

<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
.project-tit .nowrap {
	display: inline-block;
}
.project-client {
	background: url(/static/img/project-detail/lg-ess/ci.png) 50% / auto 40.5px
		no-repeat;
}

@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lg-ess/bg-overview@m.jpg);
	}
	.project-visual > div {
		padding-top: 0;
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lg-ess/bg-overview@t.jpg);
	}
	.project-tit br {
		display: none;
	}
	.project-tit .block {
		display: block;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lg-ess/bg-overview@w.jpg);
	}
	.project-visual > div {
		padding-top: 0;
	}
	.project-client {
		background-size: auto 81px;
	}
}

/* project-overview [s] */
.project-overview {
	background-color: #f6f6f6;
}
.project-overview .diagram-wrap {
	margin-top: 24px;
}
.project-overview .diagram {
	display: flex;
	justify-content: center;
	justify-content: center;
	flex-wrap: wrap;
	margin: 0 auto;
}
.project-overview .diagram .item {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 120px;
	height: 120px;
	color: #646973;
	border: 4px solid #e8e8e8;
	background-color: #f1f1f1;
	border-radius: 50%;
	text-align: center;
}
@media screen and (max-width: 711px) {
	.project-overview .diagram {
		width: 260px;
	}
	.project-overview .diagram .item:nth-child(odd) {
		margin-right: 20px;
	}
	.project-overview .diagram .item:last-child {
		margin: 0;
	}
	.project-overview .diagram .item:nth-child(n + 3) {
		margin-top: 20px;
	}
}
@media screen and (min-width: 712px) {
	.project-overview .diagram {
		display: flex;
	}
	.project-overview .diagram .item {
		width: 100px;
		height: 100px;
		padding: 0 10px;
	}
	.project-overview .diagram .item + .item {
		position: relative;
		margin-left: 30px;
	}
	.project-overview .diagram .item + .item::before {
		content: "";
		position: absolute;
		top: 50%;
		left: -25px;
		width: 15px;
		height: 1px;
		background-color: #646973;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview {
		padding-top: 45px;
		padding-bottom: 60px;
	}
	.project-overview .diagram .item {
		width: 200px;
		height: 200px;
		padding: 0 30px;
		border-width: 8px;
		font-size: 2rem;
	}
	.project-overview .diagram .item + .item {
		margin-left: 60px;
	}
	.project-overview .diagram .item + .item::before {
		left: -48px;
		width: 30px;
		height: 2px;
	}
}
/* project-overview [e] */

/* pc-web-main [s] */
.pc-web-main .swiper-container {
	overflow: visible;
	padding-bottom: 33px;
}
.pc-web-main .swiper-slide img {
	width: 100%;
	box-shadow: 0px 16px 25px 0px rgba(0, 0, 0, 0.23);
}
@media screen and (min-width: 712px) {
	.pc-web-main {
		padding-bottom: 0;
	}
	.pc-web-main .swiper-container {
		padding-bottom: 0;
	}
	.pc-web-main .swiper-slide:nth-child(1) {
		position: relative;
		z-index: 1;
		width: 56.96%;
	}
	.pc-web-main .swiper-slide:nth-child(2) {
		width: 50.31%;
		margin-top: 12.72%;
		margin-left: -6.96%;
	}
	.pc-web-main .swiper-pagination {
		display: none;
	}
}
@media screen and (min-width: 1280px) {
	.pc-web-main {
		padding-top: 95px;
	}
	.pc-web-main .project-subtit {
		margin-bottom: 60px;
	}
	.pc-web-main .swiper-container {
		overflow: visible;
		margin-right: -20px;
	}
	.pc-web-main .swiper-slide img {
		width: auto;
		max-width: inherit;
		box-shadow: 0px 33px 49px 0px rgba(0, 0, 0, 0.23);
	}
	.pc-web-main .swiper-slide:nth-child(1) {
		width: auto;
	}
	.pc-web-main .swiper-slide:nth-child(2) {
		width: auto;
		margin-top: 170px;
		margin-left: 82px;
	}
}
/* pc-web-main [e] */

/* home-battery [s] */
.home-battery {
	position: relative;
	padding-bottom: 0;
}
.home-battery::before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 50%;
	background-color: #646973;
}
.home-battery .project-subtit {
	position: relative;
	background-color: #646973;
	text-align: center;
	font-size: 2rem;
	color: #fff;
}
.home-battery .project-desc {
	position: relative;
	background-color: #646973;
	color: #fff;
}
.home-battery .swiper-area {
	position: relative;
	margin-top: 16px;
}
.home-battery .swiper-area::before {
	content: "";
	position: absolute;
	top: 0;
	right: -15px;
	left: -15px;
	height: 35%;
	background-color: #646973;
}
.home-battery .swiper-container {
	overflow: visible;
	padding-bottom: 33px;
}
.home-battery .swiper-slide img {
	width: 100%;
	box-shadow: 0px 16px 25px 0px rgba(0, 0, 0, 0.23);
}
@media screen and (max-width: 711px) {
	.home-battery::before {
		height: 60%;
	}
}
@media screen and (min-width: 712px) {
	.home-battery .swiper-area {
		margin-top: 24px;
	}
	.home-battery .swiper-area::before {
		right: -92px;
		left: -92px;
		height: 74%;
	}
}
@media screen and (min-width: 1280px) {
	.home-battery {
		padding-top: 95px;
		padding-bottom: 120px;
	}
	.home-battery .project-subtit {
		font-size: 4rem;
	}
	.home-battery .project-desc {
		text-align: center;
	}
	.home-battery .swiper-area {
		height: 504px;
		margin-top: 60px;
		padding-bottom: 50px;
		box-shadow: 0px 16px 25px 0px rgba(0, 0, 0, 0.23);
	}
	.home-battery .swiper-area::before {
		right: -340px;
		left: -340px;
		height: 83%;
	}
	.home-battery .swiper-container {
		overflow: hidden;
		height: 554px;
		padding-bottom: 50px;
	}
	.home-battery .swiper-container::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 504px;
		background-color: #fff;
	}
	.home-battery .swiper-pagination {
		bottom: 17px;
	}
	.home-battery .swiper-slide img {
		box-shadow: none;
	}
}
/* home-battery [e] */

/* ups-battery [s] */
.ups-battery {
	padding-bottom: 0;
}
.ups-battery .img-wrap {
	position: relative;
	margin-top: 16px;
}
.ups-battery .img-wrap::before {
	content: "";
	position: absolute;
	right: -160px;
	bottom: 0;
	left: -160px;
	height: 40%;
	background-color: #ebebeb;
}
.ups-battery .img-wrap img {
	position: relative;
	width: 100%;
}
@media screen and (min-width: 712px) {
	.ups-battery .img-wrap {
		position: relative;
		margin-top: 24px;
	}
	.ups-battery .img-wrap::before {
		content: "";
		position: absolute;
		right: -160px;
		bottom: 0;
		left: -160px;
		height: 40%;
		background-color: #ebebeb;
	}
	.ups-battery .img-wrap {
		margin-right: 0;
		margin-left: 0;
	}
}
@media screen and (min-width: 1280px) {
	.ups-battery .img-wrap {
		position: relative;
		margin-top: 60px;
	}
	.ups-battery .img-wrap::before {
		content: "";
		position: absolute;
		right: 0;
		left: 50%;
		bottom: 0;
		width: 1920px;
		margin-left: -960px;
		height: 40%;
		background-color: #ebebeb;
	}
	.ups-battery .img-wrap img {
		position: relative;
	}
}
/* ups-battery [e] */

/* mobile-web-main [s] */
.mobile-web-main {
	padding-bottom: 0;
	background-color: #ebebeb;
}
.mobile-web-main .img-wrap {
	margin-left: -1.55%;
}
.mobile-web-main .img-wrap img {
	width: 104.31%;
}
@media screen and (min-width: 712px) {
	.mobile-web-main .img-wrap {
		margin-left: -1.66%;
	}
	.mobile-web-main .img-wrap img {
		width: 104.66%;
	}
}
@media screen and (min-width: 1280px) {
	.mobile-web-main {
		padding-top: 95px;
	}
	.mobile-web-main .project-subtit {
		margin-bottom: 0;
	}
	.mobile-web-main .img-wrap {
		margin-top: -64px;
		margin-left: 122px;
	}
	.mobile-web-main .img-wrap img {
		width: auto;
	}
}
/* mobile-web-main [e] */

/* mobile-web-sub [s] */
.mobile-web-sub .swiper-container {
	overflow: visible;
	padding-bottom: 33px;
}
.mobile-web-sub .swiper-slide {
	width: 50.78%;
}
.mobile-web-sub .swiper-slide img {
	box-shadow: 0px 16px 25px 0px rgba(0, 0, 0, 0.23);
	border-radius: 15px;
}
@media screen and (min-width: 712px) {
	.mobile-web-sub {
		padding-top: 50px;
		padding-bottom: 50px;
	}
	.mobile-web-sub .swiper-container {
		padding-bottom: 0;
	}
	.mobile-web-sub .swiper-slide {
		width: 25.71%;
	}
	.mobile-web-sub .swiper-slide + .swiper-slide {
		margin-left: 10.52%;
	}
	.mobile-web-sub .swiper-slide:nth-child(1) {
		margin-left: 0.94%;
	}
	.mobile-web-sub .swiper-pagination {
		display: none;
	}
}
@media screen and (min-width: 1280px) {
	.mobile-web-sub {
		padding-top: 200px;
		padding-bottom: 200px;
	}
	.mobile-web-sub .swiper-slide img {
		box-shadow: 0px 33px 49px 0px rgba(0, 0, 0, 0.23);
	}
}
/* mobile-web-sub [e] */

/* style [s] */
.style {
	background-color: #ebebeb;
}
.style .point-font-wrap img {
	width: 98.79%;
}
/* .style .point-font-wrap img{width:90.625vw;} */
.style .point-color-wrap {
	margin-top: 30px;
}
.style .point-color {
	display: flex;
	flex-wrap: wrap;
	width: 265px;
	margin: 0 auto;
}
.style .point-color .item {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 75px;
	height: 75px;
	margin-right: 20px;
	border-radius: 50%;
	color: #fff;
}
.style .point-color .item:nth-child(1) {
	background-color: #c00c3f;
}
.style .point-color .item:nth-child(2) {
	background-color: #222;
}
.style .point-color .item:nth-child(3) {
	background-color: #646973;
}
.style .point-color .item:nth-child(4) {
	background-color: #666;
}
.style .point-color .item:nth-child(5) {
	background-color: #999;
}
.style .point-color .item:nth-child(6) {
	background-color: #bbb;
}
.style .point-color .item:nth-child(n + 4) {
	margin-top: 20px;
}
.style .point-color .item:nth-child(3n) {
	margin-right: 0;
}
@media screen and (min-width: 712px) {
	.style {
		padding-top: 50px;
		padding-bottom: 50px;
	}
	.style .inner-section {
		display: flex;
		justify-content: space-evenly;
	}
	.style .point-font-wrap img {
		width: 320px;
	}
	.style .point-color-wrap {
		margin-top: 0;
		margin-left: 90px;
	}
}
@media screen and (min-width: 1280px) {
	.style {
		padding-top: 170px;
		padding-bottom: 160px;
	}
	.style .point-font-wrap img {
		width: auto;
		margin-left: -20px;
	}
	.style .point-color {
		width: 440px;
	}
	.style .point-color .item {
		width: 120px;
		height: 120px;
		margin-right: 40px;
	}
}
/* style [e] */
</style>


// WEBPACK FOOTER //
// src/projects/lg-ess.vue